import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-ima/dist/videojs.ima.css';
// import hlsQualitySelector from 'videojs-hls-quality-selector';
import 'videojs-contrib-ads';
import 'videojs-ima';
import watermark from 'videojs-watermark';
import iscrrenWatermark from 'assets/iscreen/iscreen_gray.png';
import rewindButtonIcon from 'assets/icons/rewind-button-icon.svg';
import forwardButtonIcon from 'assets/icons/forward-button-icon.svg';
import nextButtonIcon from 'assets/icons/next-button-icon.svg';
import playlistIcon from 'assets/icons/playlist.svg';
import funprimeWatermark from 'assets/funprime_logo.png';
import './watermark.css';
import { useSelector } from 'react-redux';
import { addCustomButtons, addVideoJsHotkeys } from './playerCustomize';

export default function TrailerVideojs(props) {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const { videoJsOptions, onReady, onEnd, setVideoDuration, onSkipEpisode, newSeriesSlug } = props;
  videojs.registerPlugin('watermark', watermark);
  // videojs.registerPlugin('hlsQualitySelector', hlsQualitySelector);
  const platform = window.platform_info.api_key;

  const { vastTag, currentTrack } = useSelector((state) => state.video);
  const tempAdTag =
    'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/vmap_ad_samples&sz=640x480&cust_params=sample_ar%3Dpremidpostpodbumper&ciu_szs=300x250&gdfp_req=1&ad_rule=1&output=vmap&unviewed_position_start=1&env=vp&impl=s&cmsid=496&vid=short_onecue&correlator';

  //Set IMA ad options here
  const imaOptions = {
    adTagUrl: vastTag?.is_vast_show ? vastTag?.vast_tag : '',
    adLabel: 'Advertisement'
  };

  // Forward button handler
  function onPressRewind() {
    const player = playerRef.current;
    player.currentTime(player.currentTime() - 10);
  }

  // Forward button handler
  function onPressForward() {
    const player = playerRef.current;
    player.currentTime(player.currentTime() + 10);
  }

  // Forward button handler
  function onPressPlaylist() {
    console.log('Playlist button got clicked');
    setSeriesPlaylistOpen((prev) => !prev);
  }

  function onPressNext() {
    console.log('Next button got clicked');
    onSkipEpisode();
  }

  // Videojs metadata handler
  const handleLoadedMetadata = () => {
    const video = videoRef.current;
    if (!video) return;
    if (!currentTrack?.live) {
      setVideoDuration && setVideoDuration(video?.duration);
    }
  };

  /**
   * Videojs Initialization
   */
  useEffect(() => {
    // make sure Video.js player is only initialized once
    const videoElement = videoRef.current;
    videoElement.onended = function () {
      onEnd();
    };

    if (!playerRef.current) {
      if (!videoElement) return;

      const player = (playerRef.current = videojs(videoElement, videoJsOptions, () => {
        onReady && onReady(player);
      }));

      // Add custom button to control bar here
      player.ready(function () {
        addCustomButtons(this, newSeriesSlug, {
          onRewindClick: onPressRewind,
          onForwardClick: onPressForward,
          onPlaylistClick: onPressPlaylist,
          onNextClick: onPressNext
        });
        addVideoJsHotkeys(player);
      });

      // Add the videojs-contrib-quality-levels plugin to the player
      // player.qualityLevels();
      // player.qualityLevels();

      // This is optional, but you can listen for the 'qualitychange' event to track quality changes
      // player.qualityLevels().on('change', () => {
      //   const currentQuality = player.qualityLevels().currentQuality();
      //   console.log('Current quality:', currentQuality.label);
      // });
      // if (
      //   vastTag?.is_vast_show &&
      //   (currentTrack?.type === 'video' || currentTrack?.type === 'episode' || currentTrack?.live)
      // ) {
      //   player.ima(imaOptions);
      // }
      currentTrack?.watermark
        ? player.watermark({
            // image: "https://media-cldnry.s-nbcnews.com/image/upload/t_fit-2000w,f_auto,q_auto:best/streams/2013/January/130129/1C5766347-google-logo.jpg",
            image:
              platform === 'iscreen'
                ? currentTrack?.type === 'video' || currentTrack?.type === 'episode'
                  ? iscrrenWatermark
                  : ''
                : platform === 'funprime'
                ? ''
                : '',
            fadeTime: null,
            url:
              platform === 'iscreen'
                ? 'https://iscreen.com.bd'
                : platform === 'funprime'
                ? null
                : null
          })
        : '';
    } else {
      // you can update player here [update player through props]
      const player = playerRef.current;
      player.autoplay(videoJsOptions.autoplay);
      player.src(videoJsOptions.sources);
    }
  }, [videoJsOptions]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    return () => {
      if (playerRef.current) {
        playerRef.current.dispose();
        playerRef.current = null;
      }
    };
  }, []);

  return (
    <>
      <VideoBox>
        <div data-vjs-player>
          <video
            ref={videoRef}
            // onLoadedMetadata={handleLoadedMetadata}
            id="videojs-analytics-player"
            className="video-js react-player vjs-big-play-centered "
            controls
          />
        </div>
      </VideoBox>
    </>
  );
}

const VideoBox = styled.div`
  background-color: var(--dark-navy-blue);
  .eyeViewer {
    position: absolute;
    top: 7%;
    left: 4%;
    display: flex;
    align-items: center;
    column-gap: 5px;
    font-size: 12px;
  }
  .video-js .vjs-play-progress {
    background-color: var(--button-bg);
  }
  .video-js .vjs-play-progress {
    background-color: var(--button-bg);
  }
  .react-player {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    max-height: 100% !important;
    width: 100%;
    /* z-index: 1; */

    @media (max-width: 767px) {
      height: 100%;
    }
  }
  .vjs-poster {
    background-size: cover;
    ::before {
      content: '';
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.8);
    }
  }
  .vjs-big-play-button {
    background-color: transparent !important;
    border: none !important;
    font-size: 70px !important;
  }
  .skip-btn {
    position: absolute;
    z-index: 999;
    padding: 0.8em 1.3em;
    outline: none;
    background: #000;
    right: 2.5em;
    bottom: 4.5em;
    border: 1px solid #aaa;
    font-size: 1.2em;
    display: flex;
    align-items: center;
    column-gap: 5px;
    cursor: pointer;
  }
  .video-js .rewind-button {
    background: url(${rewindButtonIcon}) center no-repeat;
    background-size: 38px;
    cursor: pointer;
  }

  .video-js .forward-button {
    background: url(${forwardButtonIcon}) center no-repeat;
    background-size: 38px;
    cursor: pointer;
  }

  .video-js .playlist-button {
    background: url(${playlistIcon}) center no-repeat;
    background-size: 40px;
    cursor: pointer;
  }
  .video-js .next-button {
    background: url(${nextButtonIcon}) center no-repeat;
    background-size: 34px;
    cursor: pointer;
  }

  .video-js .vjs-control-bar {
    height: 4em;
    background-color: rgb(43 51 63 / 0%);
  }

  .vjs-button > .vjs-icon-placeholder:before {
    font-size: 2.3em;
    line-height: 1.75;
  }

  .video-js .vjs-volume-bar {
    margin: 1.85em 0.45em 1.35em;
  }
  .video-js .vjs-time-control {
    font-family: 'Poppins', sans-serif;
    font-size: 1.2em;
    line-height: 3.4em;
  }

  @media (max-width: 639px) {
    .video-js .vjs-progress-control {
      position: absolute !important;
      left: 0;
      right: 0;
      // bottom: calc(2.5em - 0.32em);
      bottom: calc(4.5em - 0.32em);
      margin: auto;
      width: calc(100% - 1.5em);
      cursor: pointer;
      height: 80%;
    }

    .vjs-button > .vjs-icon-placeholder:before {
      font-size: 2.5em !important;
    }

    .video-js .forward-button,
    .video-js .rewind-button,
    .video-js .next-button,
    .video-js .playlist-button {
      background-size: 40px;
      height: 110%;
    }

    .video-js .vjs-volume-panel {
      flex: 1;
    }
    .skip-btn {
      bottom: 6.5em;
    }
  }
`;
